import {  useParams } from "react-router-dom";
import {
  LoadingOverlay,
  Paper,
} from "@mantine/core";
import LinkedinAccount from "../../tools/linkedin/components/LinkedinAccount";
import { findLinkedinAccount } from "../../../../api/EmailAPI";
import { useEffect, useState } from "react";

const LinkedinPage = ({ handleClose, onEdited }) => {
  const { accountId } = useParams();
  const [linkedinProfile, setLinkedinProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (accountId) {
      setLoading(true);
      findLinkedinAccount(accountId)
        .then((response) =>
          setLinkedinProfile(response.data.linkedin_account_profile)
        )
        .finally(() => setLoading(false));
    }
  }, [accountId]);

  return (
    <Paper
      p={"lg"}
      gap={"xs"}
      pos={"relative"}
      h={"100%"}
      mb={16}
      style={{ boxShadow: "#00000012 0 2px 6px", overflow: "hidden" }}
      bg={"#fff"}
    >
      {loading ? (
        <LoadingOverlay visible />
      ) : (
        <LinkedinAccount
          accountProfile={linkedinProfile}
          handleClose={handleClose}
          onCreated={onEdited}
          isPage
        />
      )}
    </Paper>
  );
};

export default LinkedinPage;
